import { Auth } from 'aws-amplify';
import * as AWS from 'aws-sdk';

export class ModalImageLoader {
  static loadImageFromPath(ctx: any, imagePath: string): void {
    const delimiter = '://';
    const parts = imagePath.split(delimiter);

    if (parts.length !== 2 || !parts[1]) {
      throw new Error('Invalid S3 URL format');
    }

    const [_, path] = parts;
    const [bucket, ...keyParts] = path.split('/');
    const key = keyParts.join('/');

    console.log('bucket', bucket);
    console.log('key', key);

    Auth.currentCredentials()
      .then((credentials) => {
        AWS.config.update({
          region: 'eu-west-1',
          credentials,
        });

        const s3 = new AWS.S3();
        const params = { Bucket: bucket, Key: key };

        s3.getObject(params, (err, data) => {
          if (err) {
            console.error('❌ S3 getObject error:', err);
            return;
          }
          if (!data.Body) {
            console.error('❌ S3 returned empty body');
            return;
          }

          const contentType = data.ContentType || 'image/jpeg';
          const imageBlob = new Blob([data.Body as BlobPart], { type: contentType });

          ctx.rawBlobUrl = URL.createObjectURL(imageBlob);
          ctx.safeUrl = ctx.sanitizer.bypassSecurityTrustUrl(ctx.rawBlobUrl);
          ctx.cdr.detectChanges();
        });
      })
      .catch((error) => {
        console.error('❌ Error retrieving credentials:', error);
      });
  }
}
